<template>
  <div>
    <b-modal id="expensesExpenditureModal" ref="expensesExpenditureModal" size="lg" :title="title">
      <form>

        <div v-if="false" class="form-group">
          <label class="form-label">Outlet</label>
          <multiselect
            v-model="selectedOutlet"
            label="text"
            track-by="id"
            :options="outlets"
            :searchable="false"
            :show-labels="false"
            openDirection="below">
            <template slot="option" slot-scope="{ option }">{{ option.text }}</template>
          </multiselect>
        </div>

        <div class="form-group">
          <label class="form-label">Date</label>
          <date-range-picker
            class="w-100"
            ref="picker"
            v-model="date"
            :opens="'right'"
            :singleDatePicker="true"
            :timePicker="true"
            :showDropdowns="true"
            :always-show-calendars="true"
            :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy HH:MM' }"
            @update="onDateChange">
          </date-range-picker>
        </div>

        <div class="form-group">
          <label class="form-label">Payment Name</label>
          <input
            class="form-control bg-transparent pl-3"
            v-model="name">
        </div>

        <div class="form-group">
          <label class="form-label">Amount</label>
          <input
            type="number"
            class="form-control bg-transparent pl-3"
            v-model="amount">
        </div>

        <div class="form-group">
          <label class="form-label">Category</label>
          <multiselect
            v-model="category"
            label="expenditureType"
            track-by="expenditureTypeID"
            :options="expenditureType"
            :searchable="true"
            :show-labels="false"
            openDirection="below">
            <template slot="singleLabel" slot-scope="{ option }">{{ formatExpenditureType(option.expenditureType) }}</template>
            <template slot="option" slot-scope="{ option }">{{ formatExpenditureType(option.expenditureType) }}</template>
          </multiselect>
        </div>

        <div class="form-group">
          <label class="form-label">Invoice / Receipt</label>
          <input
            class="form-control bg-transparent pl-3"
            v-model="invoice">
        </div>

        <div class="form-group">
          <label class="form-label">Remarks</label>
          <input
            class="form-control bg-transparent pl-3"
            v-model="remarks">
        </div>

        <br>
        <br>
        <br>
        <br>
        <br>

      </form>
      <template #modal-footer="{ close }">
        <div class="row w-100">
          <div v-if="showDelete" class="col-auto">
            <b-button variant="warning" @click="confirmDeleteItem">Delete</b-button>
          </div>
          <div class="col">
          </div>
          <div class="col-auto">
            <b-button @click="close()">{{ $t('button_link.cancel') }}</b-button>
          </div>
          <div class="col-auto">
            <b-button class="ml-1" variant="primary" @click="save">{{ $t('button_link.save') }}</b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <b-modal id="expensesConfirmDeleteExpenditureModal" ref="expensesConfirmDeleteExpenditureModal" size="lg" title="Delete Expenses">
      <div>Are you sure you want to delete this expenses?</div>
      <template #modal-footer="{ close }">
        <div class="row w-100">
          <div class="col">
          </div>
          <div class="col-auto">
            <b-button @click="close()">{{ $t('button_link.cancel') }}</b-button>
          </div>
          <div class="col-auto">
            <b-button class="ml-1" variant="primary" @click="deleteItem">Yes</b-button>
          </div>
        </div>
      </template>
    </b-modal>

  </div>
</template>
<script>
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'
import { insertLeadingZero } from './../../../../assets/js/dashboard/utilities.js'
import { handleSessionExpired } from './../../../../assets/js/dashboard/dashboard'
import Swal from "sweetalert2";

export default {
  name: 'expensesExpenditureForm',
  props: {
    outlets: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
    expenditureType: {
      type: Array,
      default(rawProps) {
        return []
      },
    },
  },
  components: {
    DateRangePicker
  },
  data() {
    return {
      title: '',
      showDelete: false,

      expenditureID: null,
      selectedOutlet: {},
      date: { startDate: moment(), endDate: moment() },
      name: '',
      amount: '',
      category: {},
      invoice: '',
      remarks: '',
    }
  },
  watch: {
    "$i18n.locale"(val) {
    },
  },
  methods: {
    formatExpenditureType(text) {
      if (!text) {
        return ''
      }

      let list = []
      let temp = text.split('_')
      for (let test of temp) {
        list.push(test.charAt(0).toUpperCase() + test.slice(1))
      }
      return list.join(' ')
    },

    onDateChange(date) {
      this.date = date
    },
    show(selectedOutlet, item) {
      this.$refs['expensesExpenditureModal'].show()
      this.selectedOutlet = selectedOutlet

      if (!item) {
        this.title = 'Add Expenses'
        this.showDelete = false

        this.expenditureID = null
        let temp = moment().toDate()
        this.date = { startDate: temp, endDate: temp }
        this.name = ''
        this.amount = ''
        this.invoice = ''
        this.remarks = ''
        this.category = this.expenditureType[0]
        return
      }

      this.title = 'Edit Expenses'
      this.showDelete = true

      this.expenditureID = item['expenditureID']
      let temp = moment.unix(item['expenditureDate']).toDate()
      this.date = { startDate: temp, endDate: temp }
      this.name = item['name']
      this.amount = item['amount']
      this.invoice = item['invoice']
      this.remarks = item['remarks']
      this.category = this.expenditureType.find(k => k['expenditureTypeID'] === item['expenditureTypeID'])
    },

    save() {
      let request = {}
      request['expenditureDate'] = this.date.startDate.getTime() / 1000
      request['expenditureTypeID'] = this.category.expenditureTypeID
      request['name'] = this.name
      request['amount'] = this.amount
      request['invoice'] = this.invoice
      request['remarks'] = this.remarks

      let url
      if (this.expenditureID) {
        url = `/outlets/${this.selectedOutlet.id}/acct/expenditure/${this.expenditureID}/update`
      } else {
        url = `/outlets/${this.selectedOutlet.id}/acct/expenditure`
      }

      this.$axios({
        method: 'post',
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$util.getSessionToken() },
        data: request,
      })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: this.expenditureID ? 'Update Expenses' : 'Add Expenses',
            text: this.expenditureID ? 'Successfully update expenses' : 'Successfully add expenses',
          });

          this.$refs['expensesExpenditureModal'].hide()
          this.$emit("onModalClose");
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },
    confirmDeleteItem() {
      this.$refs['expensesConfirmDeleteExpenditureModal'].show()
    },
    deleteItem() {
      let url = `/outlets/${this.selectedOutlet.id}/acct/expenditure/${this.expenditureID}/delete`

      this.$axios({
        method: 'post',
        url: url,
        baseURL: this.$api.API_ENDPOINT_BEBUSINESS,
        headers: { token: this.$util.getSessionToken() },
      })
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: 'Delete Expenses',
            text: 'Successfully delete expenses',
          });

          this.$refs['expensesConfirmDeleteExpenditureModal'].hide()
          this.$refs['expensesExpenditureModal'].hide()
          this.$emit("onModalClose");
        })
        .catch((err) => {
          if (err && err.response && err.response.data && err.response.data.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
            return
          }

          this.$parent.$parent.setModal(this, true, true, this.$i18n.t('message.error.system_error'));
        })
    },

    closeModal(isError) {
      if (!isError) {
        this.$refs['expensesExpenditureModal'].hide()
        this.$emit('onModalClose')
      }
    }
  },
  async mounted() {
  }
}
</script>
<style scoped>
.show {
  display: block;
}

.nav-link,
.link {
  cursor: pointer;
}

.img-thumbnail {
  width: 20em;
}

.item-image {
  width: 8em;
  opacity: .5;
}

.error-validation {
  font-size: 0.6875rem;
  margin-top: 0.325rem;
  color: #fd3995;
}
</style>